import { UserRating } from "../models/userRatingModel";
import { backendRequest } from "./backendApi";
import exceptionService from "./exceptionService";

const userRatingService = {
  async fetchRatingForVisit(workflowId: string): Promise<{ data: any; error: any }> {
    const result = await backendRequest("/ratings/by-workflow", { workflowId });
    if (result.error)
      exceptionService.logError(result.error, "UserRatingService.fetchRatingForVisit");
    return result;
  },
  async putUserRating(rating: UserRating): Promise<number> {
    const { data, error } = await backendRequest<number>("/ratings/upsert", { rating });
    if (error) {
      exceptionService.logError(error, "UserRatingService.putUserRating");
      return -1;
    }
    return data ?? -1;
  },
};
export default userRatingService;
